import React, { useState, useContext } from 'react';
import Modal from './index';
import { ModalContext } from '../ModalContext';

interface Props {
    children?: React.ReactNode,
    confirm: Function | null,
    title: string,
    text?: string
}


const ModalConfirmation: React.FC<Props> = ({ children, confirm, title, text }: Props) => {

    const [showModal, closeModal] = useContext(ModalContext);

    const [loading, setLoading] = useState(false);
    const [apiResult, setApiResult] = useState<null | { status: boolean }>(null)

    const modalButtons = [
        {
            text: 'Potvrdiť',
            icon: 'check',
            onClick: () => {
                if (!confirm) {
                    return
                }
                setLoading(true);
                confirm().then(() => {
                    setLoading(false);
                    setApiResult({
                        status: true,
                    })
                    closeModal(null);
                }).catch((err: any) => {
                    setLoading(false);
                    setApiResult(err)
                })
            },
            style: 'primary'
        }, {
            text: 'Zrušiť',
            icon: 'xmark',
            onClick: 'closeModal',
            style: 'secondary'
        }
    ];


    return (


        <div>
            <Modal
                buttons={modalButtons}
                title={title}
                text={text}
                errorObject={apiResult}
                disableAllButtons={loading}
            >{children}</Modal>
        </div>


    )

}

export default ModalConfirmation
